import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { LightbulbIcon } from 'lucide-react';
const metrics = ['Domain Authority', 'Organic Keywords', 'Organic Traffic', 'Referring Domains', 'Backlinks'];
const domains = [{
  name: 'cuttingedgelending.com',
  highlight: true,
  values: ['8', '56', '9', '65', '78']
}, {
  name: 'auxiliummortgage.com',
  highlight: false,
  values: ['25', '5.8K', '1.8K', '231', '472']
}, {
  name: 'zaheedvh.com',
  highlight: false,
  values: ['10', '2,200', '1,600', '95', '272']
}, {
  name: 'greenmortgageteam.ca',
  highlight: false,
  values: ['20', '724', '32', '175', '411']
}, {
  name: 'yourmortgagesource.org',
  highlight: false,
  values: ['18', '1K', '373', '182', '242']
}];
// Mobile card view for each competitor
const CompetitorCard = ({
  domain
}: {
  domain: (typeof domains)[0];
}) => <div className={`glass-card p-4 ${domain.highlight ? 'ring-2 ring-gold-500/30 bg-gold-500/5' : ''}`} data-id="element-72">
    <h4 className={`text-sm font-bold mb-3 truncate ${domain.highlight ? 'text-gold-600' : 'text-slate-700'}`} data-id="element-73">
      {domain.name}
    </h4>
    <div className="grid grid-cols-2 gap-2" data-id="element-74">
      {metrics.map((metric, j) => <div key={j} className="flex flex-col" data-id="element-75">
          <span className="text-[10px] text-slate-400 uppercase tracking-wider font-semibold" data-id="element-76">
            {metric}
          </span>
          <span className={`text-sm font-bold ${domain.highlight ? 'text-slate-900' : 'text-slate-600'}`} data-id="element-77">
            {domain.values[j]}
          </span>
        </div>)}
    </div>
  </div>;
export function CompetitorBenchmark() {
  return <SlideLayout data-id="element-78">
      <div className="mb-6 sm:mb-10" data-id="element-79">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-80" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-81">
          Competitor Benchmarking
        </h2>
        <p className="text-sm sm:text-xl text-slate-500" data-id="element-82">
          SEO competitor analysis uncovers ranking opportunities you may not
          have seen otherwise.
        </p>
      </div>

      {/* Desktop table view */}
      <div className="hidden sm:block glass-card overflow-hidden mb-6 sm:mb-8" data-id="element-83">
        <div className="overflow-x-auto" data-id="element-84">
          <table className="w-full text-left border-collapse" data-id="element-85">
            <thead data-id="element-86">
              <tr className="bg-slate-50 border-b border-slate-200" data-id="element-87">
                <th className="p-3 sm:p-5 text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-88">
                  Domain
                </th>
                {metrics.map((metric, i) => <th key={i} className="p-3 sm:p-5 text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-wider text-center" data-id="element-89">
                    {metric}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-90">
              {domains.map((domain, i) => <tr key={i} className={domain.highlight ? 'bg-gold-500/5' : 'hover:bg-slate-50 transition-colors'} data-id="element-91">
                  <td className={`p-3 sm:p-5 font-medium text-xs sm:text-base ${domain.highlight ? 'text-gold-600 font-bold' : 'text-slate-600'}`} data-id="element-92">
                    {domain.name}
                  </td>
                  {domain.values.map((val, j) => <td key={j} className={`p-3 sm:p-5 text-center text-xs sm:text-base ${domain.highlight ? 'text-slate-900 font-bold' : 'text-slate-600'}`} data-id="element-93">
                      {val}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile card view */}
      <div className="sm:hidden space-y-3 mb-6" data-id="element-94">
        {domains.map((domain, i) => <CompetitorCard key={i} domain={domain} data-id="element-95" />)}
      </div>

      <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 rounded-xl border border-gold-500/30 bg-gradient-to-r from-slate-50 to-white shadow-sm" data-id="element-96">
        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gold-500/15 flex items-center justify-center shrink-0" data-id="element-97">
          <LightbulbIcon className="w-5 h-5 sm:w-6 sm:h-6 text-gold-600" data-id="element-98" />
        </div>
        <div data-id="element-99">
          <h4 className="text-sm sm:text-lg font-bold text-slate-900 mb-1 sm:mb-2" data-id="element-100">
            Strategic Insight
          </h4>
          <p className="text-xs sm:text-base text-slate-700 leading-relaxed" data-id="element-101">
            <strong data-id="element-102">Domain authority score</strong> grades the overall quality
            of a website — the higher the score, the more weight a domain's
            backlinks carry. <strong data-id="element-103">Backlinks</strong> from high-quality sites
            increase ranking position and visibility.{' '}
            <strong data-id="element-104">Monthly organic traffic</strong> represents free visitors
            from search engines. While auxiliummortgage.com leads with 25 DA and
            1.8K monthly traffic, Cutting Edge Lending at 8 DA has significant
            room for growth. Closing the keyword and traffic gap through
            targeted service pages, location content, and strategic link
            building will be key.
          </p>
        </div>
      </div>
    </SlideLayout>;
}